import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceModelAliasComponent } from './device-model-alias.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgDragDropModule } from 'ng-drag-drop';
import { NotifierModule } from 'angular-notifier';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

const routerConfig = [{
  path: '',
  component: DeviceModelAliasComponent
}];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routerConfig),
    NgMultiSelectDropDownModule.forRoot(),
    FormsModule , ReactiveFormsModule,UiSwitchModule, NgDragDropModule.forRoot(),
    NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'right',
          distance: 12
        },
        vertical: {
          position: 'top',
          distance: 12,
          gap: 10
        }
      },
      theme: 'material',
      behaviour: {
        autoHide: 3000,
        onClick: false,
        onMouseover: 'pauseAutoHide',
        showDismissButton: false,
        stacking: 1
      },
      animations: {
        enabled: true,
        show: {
          preset: 'slide',
          speed: 200,
          easing: 'ease'
        },
        hide: {
          preset: 'fade',
          speed: 300,
          easing: 'ease',
          offset: 50
        },
        shift: {
          speed: 300,
          easing: 'ease'
        },
        overlap: 150
      }
    })

  ],
  declarations: [
    DeviceModelAliasComponent
  ],
  exports: [
    DeviceModelAliasComponent
  ],
  providers: []
})

export class deviceModelModule { }

